// FNP-533: form-shape Zod schema for the BillableEvents filter (read-only module).
import {z} from 'zod';

export const FilterFormSchema = z.object({
    state: z.string().optional(),
    channel: z.string().optional(),
    customerId: z.string().optional(),
    dayStart: z.string().optional(),
    dayEnd: z.string().optional(),
});
